module.exports = __webpack_public_path__ + "static/media/hero.e8fc649f.jpg";